import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
import { Queries } from '@api/graphql/queries';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import { sentry } from 'sentry';
import { searchManyInputStyles } from '../../base/fc-search-many-input/fc-search-many-input.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcPendencyTypesInputComponent = /** @class */ (function () {
    function FcPendencyTypesInputComponent(fuseTranslationLoaderService, apollo, queries) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.apollo = apollo;
        this.queries = queries;
        this.shouldDisplayArchived = false;
        this.desiredStyle = searchManyInputStyles.Select;
        this.disabled = false;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcPendencyTypesInputComponent.prototype.search = function (searchTerm, limit, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var where;
            return tslib_1.__generator(this, function (_a) {
                where = {
                    nameContains: searchTerm,
                };
                if (!this.shouldDisplayArchived) {
                    where['archived'] = false;
                }
                return [2 /*return*/, this.apollo
                        .query({
                        query: this.queries.searchPendencyTypes(),
                        variables: {
                            where: where,
                            limit: limit,
                            offset: offset
                        },
                    })
                        .toPromise()
                        .then(function (result) { return result.data['pendencyTypes']['items']; })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcPendencyTypesInputComponent.prototype.displayWith = function (value) {
        return value && value.name;
    };
    return FcPendencyTypesInputComponent;
}());
export { FcPendencyTypesInputComponent };
